import './index.less';
import React from 'react';
import PropTypes from 'prop-types';

export default class QandACard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false
		};
	}

	render() {
		const { answer, question } = this.props;

		const { show } = this.state;

		return (
			<div className="QandACard">
				<div className="QandACard__question" onClick={() => this.setState({ show: !show })}>
					{question}
				</div>
				<div
					className={`QandACard__answer-wrapper ${show ? 'QandACard__answer-wrapper--show' : ''}`}
				>
					<div className={`QandACard__answer`} dangerouslySetInnerHTML={{ __html: answer }} />
				</div>
			</div>
		);
	}
}

QandACard.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired
};
